import { useLocale } from '@/hooks/useLocale';
import { LegalPageLayout } from '@/components/LegalPageLayout';
import { getLegalBundle } from '@/data/legal';

export default function TermsOfUse() {
  const { lang } = useLocale();
  return <LegalPageLayout docType="terms" bundle={getLegalBundle(lang)} />;
}
